export var createOptionsFromDictionary = dictionary => Object.keys(dictionary).map(v => ({
  label: dictionary[v],
  value: v
}), []);
export var createOptions = function createOptions() {
  for (var _len = arguments.length, options = new Array(_len), _key = 0; _key < _len; _key++) {
    options[_key] = arguments[_key];
  }
  return options.map(option => {
    if (typeof option === 'string') {
      return {
        label: option,
        value: option
      };
    } else if (Array.isArray(option)) {
      return {
        label: option[1],
        value: option[0]
      };
    } else return option;
  });
};
export default createOptions;
//# sourceMappingURL=options.js.map